import { createRouter, createWebHistory } from "vue-router";
import TheLive from "@live/TheLive.vue";
import The404 from "@status/The404.vue";
const routes = [
    { path: "/", redirect: "/live" },
    { path: "/live", component: TheLive },
    { path: "/live-timeout", component: () => import("@live/TheLiveTimeout.vue") },
    { path: "/plus", component: () => import("@plus/ThePlus.vue") },
    { path: "/terms-of-service", component: () => import("@legal/TheTerms.vue") },
    { path: "/privacy-policy", component: () => import("@legal/ThePrivacyPolicy.vue") },
    { path: "/refund-policy", component: () => import("@legal/TheRefundPolicy.vue") },
    { path: "/:pathMatch(.*)*", component: The404 },
];
const router = createRouter({
    routes,
    history: createWebHistory()
});
export default router;
